"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var api = _interopRequireWildcard(require("@/api/feedback.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isLoading: false,
      visible: false,
      dataForm: {
        content: '',
        phone: '',
        imgUrls: ''
      },
      dataRule: {
        content: [{
          required: true,
          message: '反馈内容  为必填项',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '联系电话  为必填项',
          trigger: 'blur'
        }],
        imgUrls: [{
          required: true,
          message: '图片URL列表，多个URL用逗号分隔  为必填项',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    init: function init(id) {
      var _this = this;
      this.isLoading = false;
      // 初始化表单验证规则
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(function () {
        _this.$refs['dataForm'].resetFields();
        if (_this.dataForm.id) {
          api.feedbackDetailApi(id).then(function (res) {
            _this.dataForm = res;
          });
        }
      });
    },
    // 表单数据提交
    dataSubmit: function dataSubmit() {
      var _this2 = this;
      if (this.isLoading) {
        console.log('loading...');
        return;
      }
      this.isLoading = true;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.dataForm.id) {
            api.feedbackUpdateApi(_this2.dataForm).then(function (res) {
              _this2.visible = false;
              _this2.$message.success('修改成功');
              _this2.$emit('refreshDataList');
            }).catch(function (e) {
              _this2.isLoading = false;
            });
          } else {
            api.feedbackCreateApi(_this2.dataForm).then(function (res) {
              _this2.visible = false;
              _this2.$message.success('添加成功');
              _this2.$emit('refreshDataList');
            }).catch(function (e) {
              _this2.isLoading = false;
            });
          }
        } else {
          _this2.isLoading = false;
        }
      });
    }
  }
};